import Fuse from "fuse.js";
import abbreviationAliases from "./icd10AbbreviationAliases.json";

const normalizeCode = (code = "") =>
  code
    .toString()
    .replace(/[^a-z0-9]/gi, "")
    .toUpperCase();

const normalizeSearchTerm = (term = "") =>
  term
    .toString()
    .replace(/[^a-z0-9]/gi, "")
    .toUpperCase();

export const addIcd10AbbreviationAliases = (codes) =>
  codes.map((code) => {
    const aliases = abbreviationAliases[normalizeCode(code.code)];

    return aliases ? { ...code, aliases } : code;
  });

export const createIcd10Search = (codes) => {
  const codesWithAliases = addIcd10AbbreviationAliases(codes);
  const fuse = new Fuse(codesWithAliases, {
    keys: [
      { name: "code", weight: 3 },
      { name: "aliases", weight: 2 },
      { name: "long", weight: 1 },
    ],
    threshold: 0.3,
  });

  return {
    search(query, options = {}) {
      const normalizedQuery = normalizeSearchTerm(query);
      const exactAliasItems = codesWithAliases.filter((code) =>
        code.aliases?.some((alias) => normalizeSearchTerm(alias) === normalizedQuery)
      );
      const exactAliasItemSet = new Set(exactAliasItems);
      const limit = options.limit;
      const fuzzyOptions = limit ? { ...options, limit: limit + exactAliasItems.length } : options;
      const fuzzyResults = fuse
        .search(query, fuzzyOptions)
        .filter((result) => !exactAliasItemSet.has(result.item));
      const results = [...exactAliasItems.map((item) => ({ item, score: 0 })), ...fuzzyResults];

      return limit ? results.slice(0, limit) : results;
    },
  };
};
